import { IconArrowBack, IconClose } from '@tvg/fuse-icons';
import PropTypes from 'prop-types';
import React from 'react';
import { StyledDrawerHeader, StyledDrawerHeading, StyledDrawerIconButton } from './styled-drawer-header'

const { forwardRef } = React;

const propTypes = {
	title: PropTypes.string.isRequired,
	backCallback: PropTypes.func,
	closeCallback: PropTypes.func,
	drawerHeadingId: PropTypes.string,
	hasBackButton: PropTypes.bool,
	hasDepth: PropTypes.bool,
	hasIcon: PropTypes.bool,
	srLabelBackButton: PropTypes.string,
	srLabelCloseButton: PropTypes.string,
};

const defaultProps = {
	backCallback: () => {},
	closeCallback: () => {},
	drawerHeadingId: undefined,
	hasBackButton: false,
	hasDepth: false,
	hasIcon: false,
	srLabelBackButton: undefined,
	srLabelCloseButton: undefined,
};

const DrawerHeader = forwardRef(
	(
		{
			title,
			backCallback,
			closeCallback,
			drawerHeadingId,
			hasBackButton,
			hasDepth,
			hasIcon,
			srLabelBackButton,
			srLabelCloseButton,
		},
		ref,
	) => (
		<StyledDrawerHeader hasDepth={hasDepth} ref={ref}>
			{hasBackButton && (
				<StyledDrawerIconButton
					callback={backCallback}
					className="fuse-drawer__back-button"
					icon={<IconArrowBack />}
					data-testid="fuse-drawer-back-button-test-id"
					srLabel={srLabelBackButton}
				/>
			)}
			<StyledDrawerHeading
				hasBackButton={hasBackButton}
				hasIcon={hasIcon}
				id={drawerHeadingId}
				data-testid="fuse-drawer-header-test-id"
				size="3"
				type="heading"
			>
				{title}
			</StyledDrawerHeading>
			<StyledDrawerIconButton
				callback={closeCallback}
				className="fuse-drawer__close-button"
				icon={<IconClose />}
				data-testid="fuse-drawer-close-button-data-test-id"
				srLabel={srLabelCloseButton}
			/>
		</StyledDrawerHeader>
	),
);

DrawerHeader.propTypes = propTypes;
DrawerHeader.defaultProps = defaultProps;

export default DrawerHeader;
